import type { CaseFileNode, CaseFolderNode, CaseFolderTreeResponse } from '@/services/api/cases'

export interface Phase2Workflow {
  id: string
  name: string
  color: string
  template: string
}

export type FolderTreeFolder = CaseFolderNode
export type FolderTreeFile = CaseFileNode
export type FolderTreeResponse = CaseFolderTreeResponse

// Default pipeline — Schema Extraction (v2) is currently the only
// supported pipeline. Sent verbatim as `pipeline: "schema-extraction-v2"`
// in the /v1/cases/{id}/extract request body. See
// `routers/v1/case_documents.py::extract_documents`.
export const AUTO_PIPELINE_ID = 'schema-extraction-v2'
export const AUTO_PIPELINE_LABEL = 'Auto'
export const AUTO_PIPELINE_COLOR = 'hsl(var(--primary))'

export const STATUS_OPTIONS = [
  { value: 'uploaded', label: 'Uploaded', description: 'Not yet extracted' },
  { value: 'analyzing', label: 'Analyzing', description: 'Routing decision in progress' },
  { value: 'scheduled', label: 'Pending', description: 'Queued for the extraction worker' },
  { value: 'processing', label: 'Processing', description: 'Extraction in progress' },
  { value: 'processed', label: 'Processed', description: 'Extraction complete' },
  { value: 'failed', label: 'Failed', description: 'Extraction failed' },
] as const

export interface ExtractResults {
  scheduled: number
  /** Selected files left to structured ingest: the page kept them out of the request. */
  skipped: number
  /** Documents the server left alone because they are being processed already. */
  alreadyProcessing: number
  failed: number
  errors: { document_id: string; error: string }[]
  /** Documents the server left alone with a reason it names by a code (a video it cannot analyse). */
  held: { document_id: string; code: string }[]
}
